module.exports = __webpack_public_path__ + "static/media/quattro_thumb.b906392b.webp";